import { delay } from 'q'
import users from './fakes/users'
import {
	AuthenticatedUser,
	UserServiceInterface,
	User,
	ListResponse,
	SingleResponse,
	UserListItem,
	UserUpdateFormValues,
	LogoutResponse,
	UserSelfUpdateFormValues,
	ApiToken
} from '../types'
import { createFakeListResponse, createFakeSingleResponse } from './fakes/createFakeResponse'
import tokens from './fakes/apiTokens'

export default class MockUserService implements UserServiceInterface {
	public async getSelf(): Promise<SingleResponse<AuthenticatedUser>> {
		const user: SingleResponse<AuthenticatedUser> = {
			data: {
				email: 'foo@bar.com',
				name: 'mondago',
				id: 1,
				roles: [],
				permissions: [],
				is_b2c: false,
				group: 'uk',
				disabled: false,
				api_enabled: false,
				service_providers: []
			}
		}

		return Promise.resolve(user)
	}

	public async getAll(): Promise<ListResponse<UserListItem>> {
		return createFakeListResponse(users)
	}

	public async update(id: number, values: UserUpdateFormValues): Promise<SingleResponse<User>> {
		await delay(500)
		const index = users.findIndex(user => user.id === id)
		users[index] = {
			...users[index],
			disabled: values.disabled
		}
		return createFakeSingleResponse(users[index])
	}

	public async updateSelf(id: number, values: UserSelfUpdateFormValues): Promise<void> {
		await delay(500)
		const index = users.findIndex(user => user.id === id)
		users[index] = {
			...users[index],
			email: values.email,
			name: values.name
		}
		return Promise.resolve()
	}

	public async delete(id: number): Promise<void> {
		await delay(500)
		const index = users.findIndex(user => user.id === id)
		users.splice(index, 1)
	}

	public async getTokens(): Promise<ListResponse<ApiToken>> {
		return createFakeListResponse(tokens)
	}

	public async createToken(): Promise<SingleResponse<string>> {
		return { data: 'abcd1234' }
	}

	public async deleteToken(): Promise<void> {
		return Promise.resolve()
	}

	public async logout(): Promise<SingleResponse<LogoutResponse>> {
		return Promise.resolve({ data: { url: 'https://www.mondago.com' } })
	}

	public loginUrl(): string {
		return 'https://www.mondago.com/login'
	}
}
